<script lang="ts">
    import { categories, location } from "./lib/store"
    import Footer from "./lib/components/Footer.svelte"
    import Header from "./lib/components/header/Header.svelte"
    import Notifications from "./lib/components/widgets/Notifications.svelte"
    import { baseURL } from "./config"
    import Product from "./routes/Product.svelte"
    import SidebarOverlay from "./lib/components/SidebarOverlay.svelte"
    import Checkout from "./routes/Checkout.svelte"
    import SSRSkip from "./lib/components/SSRSkip.svelte"
    import DateModal from "./lib/components/widgets/DateModal.svelte"
    import Content from "./routes/Content.svelte"
    import Products from "./routes/Products.svelte"
    import Profile from "./routes/Profile.svelte"

    export let url = ""
    console.log("test")
    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? decodeURIComponent(`?${l[1]}`) : "",
            hash: "",
            push: false,
            pop: false,
            url: `${baseURL}?${l[1]}`,
        }
    }

    let oldPath: string
    location.subscribe((l) => {
        if (l.push && oldPath != l.path) window.scrollTo(0, 0)
        oldPath = l.path
    })
</script>

<div>
    <SidebarOverlay />
    <main>
        <Header />
        {#if $location?.path?.startsWith("/product/")}
            <Product handle="{$location.path.split('/product/')[1]}" />
        {:else if $location?.path?.startsWith("/collections/")}
            {#key $location?.path}
                {#if !!$categories.length}
                    <Products categoryPath="{$location?.path?.split('/').filter((c) => c !== 'collections' && !!c)}" />
                {/if}
            {/key}
        {:else if $location?.path?.startsWith("/profile")}
            <Profile />
        {:else if $location?.path?.startsWith("/checkout")}
            <Checkout />
        {:else}
            <Content location="{$location}" />
        {/if}
        <Footer />
    </main>

    <SSRSkip />
    <Notifications />
</div>

<DateModal />

<style
    lang="less"
    global
>
    @import "./lib/assets/css/variables.less";
    @import "./lib/assets/css/main.less";
    @import "swiper/swiper-bundle.min.css";
    @import "swiper/modules/effect-fade/effect-fade";
    @import "swiper/modules/navigation/navigation";
    @import "swiper/modules/pagination/pagination";
    @import "../assets/fonts/fonts.css";
    @import "./lib/assets/css/formular.less";

    html,
    body {
        font-family: "Outfit", sans-serif;
        button {
            font-family: "Outfit", sans-serif;
        }
        @media @mobile {
            font-size: 16px;
        }
        @media @tablet {
            font-size: 20px;
        }
    }

    main {
        display: flex;
        flex-direction: column;

        min-height: 100vh;
        align-items: center;
    }
</style>
